module.exports = __webpack_public_path__ + "img/icon_lalamove.88ab3b44.png";